import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { User, UserAvailability } from 'dashboard/models/user';
import { saveCurrentUser, setRecoveryCode } from 'dashboard/redux/actions/current-user';
import dashboardStore from 'dashboard/redux/store';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiModel, ApiSingletonPayload } from 'lib/interfaces/api';

export const rotateRecoveryCode = (): DashboardThunkAction => async (dispatch) => {
  const {
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    meta: { 'recovery-code': recoveryCode },
  } = await SessionClientDashboard.postResourceSingletonAction<
    User,
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    ApiSingletonPayload<unknown, ApiModel.CurrentUser>,
    { 'recovery-code': string }
  >({ type: ApiModel.CurrentUser }, 'rotate-recovery-code');

  dispatch(setRecoveryCode(recoveryCode));
};

export const updateAvailability = async (availability: UserAvailability) => {
  const response = await SessionClientDashboard.updateResourceSingleton<User>({
    attributes: {
      availability: availability,
    },
    type: ApiModel.CurrentUser as const,
  });
  dashboardStore.dispatch(saveCurrentUser(response.data));
};
